export default __webpack_public_path__ + "static/tovar-8b0df10ead799bc01467f2230657ebe5.png";